import React from 'react';

import {getNextOffset, getPreviousOffset} from '../../general/selectors';

import Button from '../../base-image/components/ChangeImageButton';

const Buttons = [
    {id: 'prev', label: '-24 h', action: getPreviousOffset},
    {id: 'next', label: '+24 h', action: getNextOffset},
];

const DateSwitch = () => Buttons.map(({id, label, action}) => (
    <Button key={id} className={id} label={label} action={action} showLabel />
));

export default DateSwitch;
